import { httpRequest } from "../../../utils/HttpRequest";
import { ICompanyDetail } from "./companyTypes";
import { IPage } from "@/types/AppTypes";

class CompanyService {
    async page(searchVo: ICompanyDetail) {
        const apiUrl = "/web/honor/search_page";
        return await httpRequest.post<IPage<ICompanyDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/web/honor/search_one/${id}`;
        return await httpRequest.get<ICompanyDetail>(apiUrl);
    }
    async insert(insertVo: ICompanyDetail) {
        const apiUrl = `/web/honor/insert`;
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: ICompanyDetail) {
        const apiUrl = `/web/honor/update`;
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async delete(ids:object) {
        const apiUrl = `/web/honor/delete`;
        return await httpRequest.post<boolean>(apiUrl,ids);
    }
}
export const companyService = new CompanyService();
